export default __webpack_public_path__ + "static/media/soriana1.bab45d3f.jpg";